import * as React from 'react';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import Layout from "../../Components/layouts";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import aiImg from '../../Assets/images/ai.png';
import projectsImg from '../../Assets/images/projects.png';
import Typography from '@material-ui/core/Typography';
import { Button } from '@material-ui/core';
import { AssesmentsSummary } from '../../utils/constants'
import commonStyles from 'theme/commonStyles';
import variables from '../../Sys/variable.scss';

const useStyles = makeStyles((theme) => ({
    heading: {
        color: variables.labelcolor,
        fontSize: '23px',
        fontWeight: '500',
        marginBottom: 20
    },
    root: {
        display: 'flex',
        minHeight: 180,
        background: variables.headerColor,
        boxShadow: "0px 4px 30px rgba(12, 41, 84, 0.1)",
        borderRadius: 5,
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
        }
    },
    cardDetails: {
        display: 'flex',
        flexDirection: 'column',
    },
    content: {
        flex: '1 1 auto',
        minWidth: 0,
        maxWidth: 'none',
    },
    cover: {
        width: 174,
        height: 132,
        paddingTop: 17,
        marginTop: 25,
        marginLeft: 20,
        borderRadius: 5,
        maxWidth: '20%',
        flexShrink: 0,
        [theme.breakpoints.between('sm', 'md')]: {
            width: 110,
            minWidth: 110,
            height: 120,
            maxWidth: 'none',
            marginLeft: 12,
            marginTop: 18,
            paddingTop: 0,
        },
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            maxWidth: '100%',
            height: 140,
            marginLeft: 0,
            marginTop: 0,
            paddingTop: 0,
            borderRadius: '5px 5px 0 0',
        }
    },
    controls: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(1),
        paddingBottom: theme.spacing(1),
    },
    cardTitle: {
        color: variables.labelcolor,
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: '1.05rem',
            lineHeight: 1.2,
        }
    },
    cardDesc: {
        color: variables.darkThemeText,
    },
    cardSubTitle: {
        fontFamily: 'Inter',
        fontStyle: 'normal',
        color: "#3D7DDD",
    },
    title: {
        fontSize: "1.3rem",
        lineHeight: 1.2,
        overflowWrap: 'anywhere',
        [theme.breakpoints.between('sm', 'md')]: {
            fontSize: "0.95rem",
        }
    },
    cardActions: {
        display: 'flex',
        justifyContent: "space-between",
        marginTop: 10
    },
    launchBtn: {
        fontSize: 12,
        borderRadius: 5,
        padding: '12px 28px',
        [theme.breakpoints.down('xs')]: {
            width: '100%',
            padding: '10px 16px',
        }
    }
}));


const DynamicCard = ({ item }) => {
    const classes = useStyles();

    return (
        <>
            <Grid item xs={12} sm={item.width}>
                <Card className={classes.root}>
                    <CardMedia
                        className={classes.cover}
                        image={item.image}
                        title={item.title}
                    />
                    <CardContent className={classes.content}>
                        <Typography className={classes.cardTitle}>
                            {item.title}
                        </Typography>
                        <Typography className={classes.title} variant="h1" color="primary">
                            {item.subTitle}
                        </Typography>
                        <Typography variant="h1" color="primary">
                            {item.totalCount}
                        </Typography>
                        <div className={classes.cardActions}>
                            <Button className={classes.launchBtn} variant="outlined" color="primary">
                                Launch</Button>
                        </div>
                    </CardContent>
                </Card>
            </Grid>
        </>
    )
}

const Assesments = () => {

    const classes = useStyles();
    const commonClasses = commonStyles();

    const userCardData = [
        {
            title: 'Assignments are Due',
            subTitle: 'Digital Readiness Assignment',
            image: aiImg,
            width: 6
        },
        {
            title: 'Assignments are Due',
            subTitle: 'Game Changer Index Assessment',
            image: projectsImg,
            width: 6
        },
        {
            title: 'Assignments are Due',
            subTitle: 'Digital Talent Maturity Model',
            image: aiImg,
            width: 6
        },
        {
            title: 'Assignments are Due',
            subTitle: 'AI Maturity Model',
            image: aiImg,
            width: 6
        },
    ];

    return (
        <Layout>
            <main>
                <div className={commonClasses.contentWrapper}>
                    <Typography
                        variant="subtitle2"
                        className={classes.heading}
                        color="textPrimary">
                        My Assessments
                    </Typography>
                    <Typography variant="subtitle1" style={{ color: variables.darkThemeText }} >
                        {AssesmentsSummary}
                    </Typography>
                    <Grid container spacing={2} style={{ marginTop: 24 }}>
                        {userCardData.map((item) => (
                            <DynamicCard key={item.subTitle} item={item} />
                        ))}
                    </Grid>
                </div>
            </main>
        </Layout>
    );
}

export default Assesments;